import { BarChart, EventNote } from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import DashboardIcon from "@mui/icons-material/Dashboard";
import GroupIcon from "@mui/icons-material/Group";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import ListAltIcon from "@mui/icons-material/ListAlt";
import PaymentIcon from "@mui/icons-material/Payment";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import InboxIcon from "@mui/icons-material/Inbox";
import DraftsIcon from "@mui/icons-material/Drafts";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import GroupsIcon from "@mui/icons-material/Groups";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import MenuIcon from "@mui/icons-material/Menu";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SettingsIcon from "@mui/icons-material/Settings";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import TouchAppIcon from "@mui/icons-material/Tablet";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import EngineeringIcon from "@mui/icons-material/Engineering";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import ChecklistIcon from "@mui/icons-material/Checklist";
import FlightIcon from "@mui/icons-material/Flight";
import CelebrationIcon from "@mui/icons-material/Celebration";
import PaymentsIcon from "@mui/icons-material/Payments";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  AppBar,
  Badge,
  Box,
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import arroe from "../assets/panel-arrow.svg";
import scanologo from "../assets/scanologo.png";
import scanologoWhite from "../assets/scanOLogoWhite.png";
import PageLoader from "../components/Loader";
import ModalActivations from "../components/ModalActivations";
import OverAllDaywise from "../components/OverAllDaywise";
import OverAllMonthwise from "../components/OverAllMonthwise";
import RoleLanding from "../components/RoleLanding";
import Title from "../components/PageTitle";
import { useToast } from "../components/Toast";
import useIsMobile from "../Hooks/useIsMobile";
import apiService from "../Services/api.service";
import {
  setUnreadCount,
  getUnreadCount,
  getUserInfo,
  getPermissions,
} from "../store/rootReducer";
const drawerWidth = 220;
const Dashboard = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false); // State for mobile drawer visibility
  const [doctors, setDoctors] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [kiosk, setKiosk] = useState([]);
  const [user, setUser] = useState([]);
  const [scanCount, setScanCount] = useState([]);
  const [temporaryCount, setTemporaryCount] = useState(0);
  const [fullyCount, setFullyCount] = useState(0);
  const [disabledCount, setDisabledCount] = useState(0);
  const [notActivatedCount, setNotActivatedCount] = useState(0);
  const [temporaryList, setTemporaryList] = useState([0]);
  const [fullyList, setFullyList] = useState([0]);
  const [disabledList, setDisabledList] = useState([0]);
  const [notActivatedList, setNotActivatedList] = useState([0]);
  const [clinics, setClinics] = React.useState([]);
  const [isModalOpen, setModalOpen] = React.useState(false);
  const [label, setLabel] = useState();
  const [collapsed, setCollapsed] = useState(false);
  const unreadCount = useSelector(getUnreadCount);
  const userInfo = useSelector(getUserInfo);
  console.log("userInfo:", userInfo);
  const permissions = useSelector(getPermissions) || {};
  const userRoles = Array.isArray(userInfo?.role) ? userInfo.role : [userInfo?.role].filter(Boolean);
  const isAdmin = userRoles.includes("admin");
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  const navigate = useNavigate();
  //const isMobile = useIsMobile();
  const [Loader, isLoader] = useState(false);
  const theme = useTheme();
  const token = localStorage.getItem("token");
  const Toast = useToast();

  const MENU_GROUPS = [
    {
      label: "Overview",
      alwaysOpen: true,
      items: [
        { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard", permissionKey: "dashboard" },
        { text: "My Queue", icon: <InboxIcon />, path: "/dashboard/queue", permissionKey: "actionItems" },
        { text: "Support", icon: <SupportAgentIcon />, path: "/dashboard/support", permissionKey: "tickets" },
      ],
    },
    {
      // Not a real "flow" — kept outside every collapsible group, always
      // visible, same as Overview/Account.
      label: "General",
      alwaysOpen: true,
      items: [
        { text: "Doctor", icon: <MedicalServicesIcon />, path: "/dashboard/doctor", permissionKey: "doctors" },
        { text: "Kiosk", icon: <TouchAppIcon />, path: "/dashboard/Kiosk", permissionKey: "kiosks" },
        { text: "Patients", icon: <GroupIcon />, path: "/dashboard/user", permissionKey: "users" },
        { text: "Scans", icon: <DocumentScannerIcon />, path: "/dashboard/scans", permissionKey: "users" },
      ],
    },
    {
      label: "Sales & Orders",
      items: [
        { text: "New Order", icon: <NoteAddIcon />, path: "/dashboard/orders/add-order", permissionKey: "ordersCreate" },
        { text: "Slack Deals", icon: <ChatBubbleOutlineIcon />, path: "/dashboard/slack-deals", permissionKey: "ordersCreate" },
        { text: "Orders", icon: <ListAltIcon />, path: "/dashboard/orders", permissionKey: "orders" },
        { text: "Quotations", icon: <RequestQuoteIcon />, path: "/dashboard/quotations", permissionKey: "quotationsTab" },
        { text: "Needs Action", icon: <AssignmentLateIcon />, path: "/dashboard/needs-action", permissionKey: "needsAction" },
        { text: "Payment Links", icon: <PaymentIcon />, path: "/dashboard/payment-links", permissionKey: "paymentLinks" },
        { text: "Team Pipeline", icon: <ViewKanbanIcon />, path: "/dashboard/pipeline", permissionKey: "pipeline" },
        { text: "Stalled Orders", icon: <HourglassBottomIcon />, path: "/dashboard/stalled-orders", permissionKey: "pipeline" },
        { text: "Specialists", icon: <GroupsIcon />, path: "/dashboard/specialists", permissionKey: "pipeline" },
      ],
    },
    {
      label: "Ops Associate",
      items: [
        { text: "Purchase Agreements", icon: <PublishedWithChangesIcon />, path: "/dashboard/purchase-agreements", permissionKey: "agreementActions" },
        { text: "Ready to Ship", icon: <Inventory2Icon />, path: "/dashboard/ready-to-ship", permissionKey: "readyToShip" },
        { text: "Shipments", icon: <LocalShippingIcon />, path: "/dashboard/shipments", permissionKey: "predispatch" },
      ],
    },
    {
      label: "Accounts",
      items: [
        { text: "Payout Review", icon: <PaymentsIcon />, path: "/dashboard/payout-review", permissionKey: "payoutReview" },
      ],
    },
    {
      label: "Ops Lead",
      items: [
        { text: "Technicians", icon: <EngineeringIcon />, path: "/dashboard/technicians", permissionKey: "installation" },
        { text: "Travel Plan", icon: <CalendarMonthIcon />, path: "/dashboard/travel-plan", permissionKey: "installation" },
        { text: "Shipped Orders", icon: <FlightTakeoffIcon />, path: "/dashboard/shipped-orders", permissionKey: "shippedOrders" },
        { text: "Expense Approvals", icon: <PaymentsIcon />, path: "/dashboard/expense-approvals", permissionKey: "expenseClaimsApprove" },
      ],
    },
    {
      label: "Technician",
      items: [
        { text: "Checklists", icon: <ChecklistIcon />, path: "/dashboard/checklists", permissionKey: "technicianJobs" },
        { text: "My Travel", icon: <FlightIcon />, path: "/dashboard/my-travel", permissionKey: "technicianJobs" },
        { text: "My Expenses", icon: <ReceiptLongIcon />, path: "/dashboard/my-expenses", permissionKey: "expenseClaimsFile" },
      ],
    },
    {
      label: "Engagement Officer",
      items: [
        { text: "Engagement", icon: <EventNote />, path: "/dashboard/engagementTracker", permissionKey: "engagements" },
        { text: "Onboarding Calls", icon: <PhoneInTalkIcon />, path: "/dashboard/engagement-officer/onboarding-calls", permissionKey: "engagementOfficer" },
        { text: "Inaugurations", icon: <CelebrationIcon />, path: "/dashboard/inaugurations", permissionKey: "inaugurations" },
        { text: "Engagement Overview", icon: <DashboardIcon />, path: "/dashboard/engagement/overview", permissionKey: "engagementOverview" },
        { text: "My Day", icon: <EventNote />, path: "/dashboard/engagement/my-day", permissionKey: "engagementMyDay" },
        { text: "Clinics", icon: <MedicalServicesIcon />, path: "/dashboard/engagement/clinics", permissionKey: "engagementClinics" },
        { text: "Renewals", icon: <PaymentsIcon />, path: "/dashboard/engagement/renewals", permissionKey: "engagementRenewals" },
        { text: "Screening camps", icon: <GroupsIcon />, path: "/dashboard/engagement/camps", permissionKey: "engagementCamps" },
        { text: "Support tickets", icon: <SupportAgentIcon />, path: "/dashboard/engagement/tickets", permissionKey: "engagementTickets" },
        { text: "Team overview", icon: <GroupIcon />, path: "/dashboard/engagement/team", permissionKey: "engagementTeamOverview" },
        { text: "Settings and rules", icon: <SettingsIcon />, path: "/dashboard/engagement/settings", permissionKey: "engagementSettings" },
      ],
    },
    {
      label: "Account",
      alwaysOpen: true,
      items: [
        { text: "Analytics", icon: <BarChart />, path: "/dashboard/analytics", permissionKey: "analytics" },
        { text: "Settings", icon: <SettingsIcon />, path: "/dashboard/settings" },
        { text: "Profile", icon: <AccountCircleIcon />, path: "/dashboard/profile" },
        { text: "Tags", icon: <ChatBubbleOutlineIcon />, path: "/dashboard/tags" },
      ],
    },
  ];

  const visibleGroups = MENU_GROUPS.map((group) => ({
    ...group,
    items: group.items.filter((item) => !item.permissionKey || permissions[item.permissionKey]),
  })).filter((group) => group.items.length > 0);

  // Marks the boundary between the always-visible tabs and the collapsible
  // role-flow groups, so a divider can separate them visually.
  const firstCollapsibleGroupLabel = visibleGroups.find((group) => !group.alwaysOpen)?.label;

  // Flat list still used for the collapsed (icon-only) desktop sidebar,
  // where group headers wouldn't have room to render anyway.
  const visibleMenuItems = visibleGroups.flatMap((group) => group.items);

  const [openGroup, setOpenGroup] = useState(null);

  useEffect(() => {
    const activeGroup = visibleGroups.find((group) =>
      group.items.some((item) => item.path === location.pathname),
    );
    if (activeGroup && !activeGroup.alwaysOpen) {
      setOpenGroup(activeGroup.label);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  // Check if the current path is the login page
  const isLoginPage = location.pathname === "/login";

  const getAllCounts = async () => {
    isLoader(true);
    try {
      const auth = token;
      const mapped = await apiService.getCounts(auth);
      isLoader(false);
      setKiosk(mapped.getAllCounts.kioskCounts);
      setDoctors(mapped.getAllCounts.doctorCounts);
      setUser(mapped.getAllCounts.userCounts);
      setScanCount(mapped.getAllCounts.totalScans);
    } catch (error) {
      isLoader(false);
      console.log("errrrrr getDoctors", error);
      Toast.error("Error while Fetching kiosk");
    } finally {
      isLoader(false);
    }
  };

  const getCount = async () => {
    isLoader(true);
    try {
      const count = await axios.get(
        `${process.env.REACT_APP_API_HOST_URL}/ops/v1/activations/activated-count`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setTemporaryCount(count.data.temporaryCount);
      setFullyCount(count.data.fullyCount);
      setDisabledCount(count.data.disabledCount);
      setNotActivatedCount(count.data.notActivatedCount);
      setTemporaryList(count.data.temporaryActivatedList);
      setFullyList(count.data.fullyActivatedList);
      setDisabledList(count.data.disabledKioskList);
      setNotActivatedList(count.data.notActivatedKioskList);
      isLoader(false);
    } catch (error) {
      isLoader(false);
      Toast.error("Error while Fetching counts");
    } finally {
      isLoader(false);
    }
  };
  const handleClickDoctor = () => {
    navigate("/dashboard/doctor/");
  };
  const handleClickPatient = () => {
    navigate("/dashboard/user/");
  };
  const handleClickKiosk = () => {
    navigate("/dashboard/Kiosk/");
  };
  useEffect(() => {
    if (!token) return;

    const fetchUnreadCount = async () => {
      try {
        const res = await apiService.getUnreadCount(token);

        dispatch(setUnreadCount(res));
      } catch (error) {
        console.error("Unread count error:", error);
      }
    };

    fetchUnreadCount();
  }, [token]);

  useEffect(() => {
    if (!token) {
      isLoader(true);
      return;
    }
    if (permissions.dashboard) {
      getAllCounts();
    }
    if (permissions.activations) {
      getCount();
    }
  }, [token, permissions.dashboard, permissions.activations]);

  const countCards = [
    {
      label: "Temporary Activated",
      count: temporaryCount,
      bgColor: "#fff3cd",
      icon: "⏳",
    },
    {
      label: "Fully Activated",
      count: fullyCount,
      bgColor: "#d4edda",
      icon: "✅",
    },
    { label: "Disabled", count: disabledCount, bgColor: "#d6d8db", icon: "❌" },
    {
      label: "Not Activated",
      count: notActivatedCount,
      bgColor: "#f8d7da",
      icon: "⚠️",
    },
  ];

  const handleCardClick = async (label) => {
    setLabel(label);
    const kioskIds =
      label === "Temporary Activated"
        ? temporaryList
        : label === "Fully Activated"
          ? fullyList
          : label === "Disabled"
            ? disabledList
            : label === "Not Activated"
              ? notActivatedList
              : [];

    // Only proceed if kioskIds is not empty
    if (kioskIds.length > 0) {
      try {
        const requestBody = { kioskIds: kioskIds };

        const list = await axios.post(
          `${process.env.REACT_APP_API_HOST_URL}/ops/v1/kiosks/clinics`,
          requestBody, // Send the body here
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (list.data.clinics.length > 0) {
          setClinics(list.data.clinics);
          setModalOpen(true);
        } else {
          Toast.error(`No clinics available for ${label}`);
        }
      } catch (error) {
        Toast.error(`Error while Fetching ${label}`);
      }
    } else {
      Toast.warning(`No Kiosk IDs available for ${label}`);
    }

    // You can perform other actions here as needed
  };

  const Card = ({ label, count, bgColor, icon, onClick }) => (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: bgColor,
        padding: isMobile ? 1 : 3,
        borderRadius: 2,
        boxShadow: 3,
        marginBottom: 2,
        transition: "transform 0.3s ease",
        width: "100%",
        boxSizing: "border-box",
        "&:hover": { transform: "scale(1.05)" },
      }}
    >
      <Typography variant="h6" fontWeight="bold" color="black">
        {label}
      </Typography>
      <Box sx={{ fontSize: isMobile ? "1rem" : "3rem", my: isMobile ? 1 : 2 }}>
        {icon}
      </Box>
      <Typography
        variant="h4"
        fontWeight="bold"
        color={
          theme.palette.mode === "dark" ? "black" : theme.palette.primary.main
        }
      >
        {count}
      </Typography>
    </Box>
  );

  const InfoCard = ({ title, count, description, onClick, bgColor }) => (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: "background.paper",
        boxShadow: 3,
        borderRadius: 2,
        p: 4,
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.3s ease",
        width: "100%",
        height: "100%%",
        "&:hover": { transform: "scale(1.05)", boxShadow: 6 },
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: isMobile ? -20 : -30,
          right: -25,
          width: isMobile ? 100 : 150,
          height: isMobile ? 100 : 150,
          backgroundColor: bgColor,
          borderRadius: "50%",
          opacity: 0.3,
          zIndex: 0,
        }}
      />
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <Typography variant="h6" fontWeight="bold" color="text.secondary">
          {title}
        </Typography>
        <Typography variant="h3" color="primary.main" fontWeight="bold" mt={2}>
          {count}
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          {description}
        </Typography>
      </Box>
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        height: "100vh",
      }}
    >
      {/* Conditionally render AppBar and Drawer based on the current path */}
      {!isLoginPage && isMobile && (
        <AppBar
          position="fixed"
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={toggleDrawer}
              sx={{ display: { sm: "none" } }} // Show hamburger menu on mobile only
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap component="div">
              scanO Ops
            </Typography>
          </Toolbar>
        </AppBar>
      )}

      {/* Permanent Drawer for Desktop */}
      {!isLoginPage && (
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", sm: "block" },
            [`& .MuiDrawer-paper`]: {
              width: collapsed ? "60px" : drawerWidth,
              transition: "width 0.3s",
              overflowX: "hidden",
              boxSizing: "border-box",
              backgroundColor: "#0B0C10",
            },
          }}
        >
          <Box
            sx={{
              background: "#70707080",

              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.4)", // Optional shadow
              display: "flex",
              justifyContent: collapsed ? "center" : "right",
              padding: 1,
              margin: collapsed ? "10%" : "0",
              marginLeft: !collapsed ? "80%" : "10%",

              marginTop: 1,
              borderRadius: 2,
            }}
            onClick={toggleSidebar}
          >
            <img
              src={arroe} // Replace with your arrow SVG
              alt="toggle"
              width={20}
              height={20}
              style={{
                transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.6s",
              }}
            />
          </Box>
          <List>
            {/* Logo */}
            {!collapsed && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  marginBottom: 2,
                  marginLeft: 2,
                }}
              >
                <img src={scanologoWhite} width={100} height={45} alt="Logo" />
              </Box>
            )}
            {/* Menu Items */}
            {collapsed
              ? visibleMenuItems.map((item) => {
                  const isTags = item.text === "Tags";

                  return (
                    <ListItem
                      key={item.text}
                      component={Link}
                      to={item.path}
                      selected={location.pathname === item.path}
                      sx={{
                        borderRadius: "8px",
                        backgroundColor:
                          location.pathname === item.path ? "#fff" : "transparent",
                        color:
                          location.pathname === item.path
                            ? (theme) => theme.palette.primary.main
                            : "#fff",
                        borderLeft:
                          location.pathname === item.path
                            ? `4px solid ${(theme) => theme.palette.primary.main}`
                            : "none",
                        "&:hover": {
                          backgroundColor:
                            location.pathname === item.path ? "#fff" : "#1F2833",
                        },
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          color:
                            location.pathname === item.path
                              ? (theme) => theme.palette.primary.main
                              : "#fff",
                        }}
                      >
                        {isTags && unreadCount > 0 ? (
                          <Badge
                            badgeContent={unreadCount}
                            color="error"
                            overlap="circular"
                            anchorOrigin={{
                              vertical: "top",
                              horizontal: "right",
                            }}
                          >
                            {item.icon}
                          </Badge>
                        ) : (
                          item.icon
                        )}
                      </ListItemIcon>
                    </ListItem>
                  );
                })
              : !isAdmin
                ? visibleMenuItems.map((item) => {
                    const isTags = item.text === "Tags";

                    return (
                      <ListItem
                        key={item.text}
                        component={Link}
                        to={item.path}
                        selected={location.pathname === item.path}
                        sx={{
                          borderRadius: "8px",
                          backgroundColor:
                            location.pathname === item.path ? "#fff" : "transparent",
                          color:
                            location.pathname === item.path
                              ? (theme) => theme.palette.primary.main
                              : "#fff",
                          borderLeft:
                            location.pathname === item.path
                              ? `4px solid ${(theme) => theme.palette.primary.main}`
                              : "none",
                          "&:hover": {
                            backgroundColor:
                              location.pathname === item.path ? "#fff" : "#1F2833",
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            color:
                              location.pathname === item.path
                                ? (theme) => theme.palette.primary.main
                                : "#fff",
                          }}
                        >
                          {isTags && unreadCount > 0 ? (
                            <Badge
                              badgeContent={unreadCount}
                              color="error"
                              overlap="circular"
                              anchorOrigin={{ vertical: "top", horizontal: "right" }}
                            >
                              {item.icon}
                            </Badge>
                          ) : (
                            item.icon
                          )}
                        </ListItemIcon>
                        <ListItemText primary={item.text} />
                      </ListItem>
                    );
                  })
                : visibleGroups.map((group) => (
                  <React.Fragment key={group.label}>
                    {group.label === firstCollapsibleGroupLabel && (
                      <Divider sx={{ borderColor: "rgba(255,255,255,0.15)", my: 1 }} />
                    )}
                    {!group.alwaysOpen && (
                      <ListItemButton
                        onClick={() =>
                          setOpenGroup(openGroup === group.label ? null : group.label)
                        }
                        sx={{
                          borderRadius: "8px",
                          color: "#fff",
                          opacity: 0.75,
                          marginTop: "6px",
                          paddingTop: "10px",
                          paddingBottom: "10px",
                          "&:hover": { backgroundColor: "#1F2833", opacity: 1 },
                        }}
                      >
                        <ListItemText
                          primary={group.label}
                          primaryTypographyProps={{
                            fontSize: 12,
                            fontWeight: 600,
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        />
                        {openGroup === group.label ? (
                          <ExpandLessIcon fontSize="small" sx={{ color: "#fff" }} />
                        ) : (
                          <ExpandMoreIcon fontSize="small" sx={{ color: "#fff" }} />
                        )}
                      </ListItemButton>
                    )}
                    <Collapse
                      in={group.alwaysOpen || openGroup === group.label}
                      timeout="auto"
                      unmountOnExit={!group.alwaysOpen}
                    >
                      <List component="div" disablePadding>
                        {group.items.map((item) => {
                          const isTags = item.text === "Tags";

                          return (
                            <ListItem
                              key={item.text}
                              component={Link}
                              to={item.path}
                              selected={location.pathname === item.path}
                              sx={{
                                borderRadius: "8px",
                                pl: group.alwaysOpen ? 2 : 4,
                                backgroundColor:
                                  location.pathname === item.path ? "#fff" : "transparent",
                                color:
                                  location.pathname === item.path
                                    ? (theme) => theme.palette.primary.main
                                    : "#fff",
                                borderLeft:
                                  location.pathname === item.path
                                    ? `4px solid ${(theme) => theme.palette.primary.main}`
                                    : "none",
                                "&:hover": {
                                  backgroundColor:
                                    location.pathname === item.path ? "#fff" : "#1F2833",
                                },
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  color:
                                    location.pathname === item.path
                                      ? (theme) => theme.palette.primary.main
                                      : "#fff",
                                }}
                              >
                                {isTags && unreadCount > 0 ? (
                                  <Badge
                                    badgeContent={unreadCount}
                                    color="error"
                                    overlap="circular"
                                    anchorOrigin={{
                                      vertical: "top",
                                      horizontal: "right",
                                    }}
                                  >
                                    {item.icon}
                                  </Badge>
                                ) : (
                                  item.icon
                                )}
                              </ListItemIcon>
                              <ListItemText primary={item.text} />
                            </ListItem>
                          );
                        })}
                      </List>
                    </Collapse>
                  </React.Fragment>
                ))}
          </List>
        </Drawer>
      )}

      {/* Temporary Drawer for Mobile */}
      {!isLoginPage && (
        <Drawer
          variant="temporary"
          open={drawerOpen}
          onClose={toggleDrawer} // Close drawer when clicked outside or on menu item
          sx={{
            display: { xs: "block", sm: "none" }, // Show on mobile only
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
        >
          <List>
            <Box
              sx={{
                display: "flex",
                marginTop: 7,
                marginLeft: 2,
              }}
            >
              <img
                src={theme.palette.mode === "dark" ? scanologoWhite : scanologo}
                width={100}
                height={45}
                alt="Logo"
              />
            </Box>

            {/* Menu Items */}
            {!isAdmin
              ? visibleMenuItems.map((item) => (
                  <ListItem
                    key={item.text}
                    component={Link}
                    to={item.path}
                    onClick={toggleDrawer}
                    selected={location.pathname === item.path}
                    sx={{
                      backgroundColor:
                        location.pathname === item.path
                          ? (theme) => theme.palette.primary.main
                          : "transparent",
                      color:
                        location.pathname === item.path
                          ? "#fff"
                          : (theme) => theme.palette.text.primary,
                      borderLeft:
                        location.pathname === item.path
                          ? `4px solid ${(theme) => theme.palette.primary.main}`
                          : "none",
                      "&:hover": {
                        backgroundColor:
                          location.pathname === item.path
                            ? (theme) => theme.palette.primary.main
                            : (theme) => theme.palette.action.hover,
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        color:
                          location.pathname === item.path
                            ? "#fff"
                            : (theme) => theme.palette.text.primary,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <ListItemText primary={item.text} />
                  </ListItem>
                ))
              : visibleGroups.map((group) => (
              <React.Fragment key={group.label}>
                {group.label === firstCollapsibleGroupLabel && (
                  <Divider sx={{ my: 1 }} />
                )}
                {!group.alwaysOpen && (
                  <ListItemButton
                    onClick={() =>
                      setOpenGroup(openGroup === group.label ? null : group.label)
                    }
                    sx={{
                      color: (theme) => theme.palette.text.secondary,
                      marginTop: "6px",
                      paddingTop: "10px",
                      paddingBottom: "10px",
                      "&:hover": { backgroundColor: (theme) => theme.palette.action.hover },
                    }}
                  >
                    <ListItemText
                      primary={group.label}
                      primaryTypographyProps={{
                        fontSize: 12,
                        fontWeight: 600,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    />
                    {openGroup === group.label ? (
                      <ExpandLessIcon fontSize="small" />
                    ) : (
                      <ExpandMoreIcon fontSize="small" />
                    )}
                  </ListItemButton>
                )}
                <Collapse
                  in={group.alwaysOpen || openGroup === group.label}
                  timeout="auto"
                  unmountOnExit={!group.alwaysOpen}
                >
                  <List component="div" disablePadding>
                    {group.items.map((item) => (
                      <ListItem
                        key={item.text}
                        component={Link}
                        to={item.path}
                        onClick={toggleDrawer}
                        selected={location.pathname === item.path}
                        sx={{
                          pl: group.alwaysOpen ? 2 : 4,
                          backgroundColor:
                            location.pathname === item.path
                              ? (theme) => theme.palette.primary.main
                              : "transparent",
                          color:
                            location.pathname === item.path
                              ? "#fff"
                              : (theme) => theme.palette.text.primary,
                          borderLeft:
                            location.pathname === item.path
                              ? `4px solid ${(theme) => theme.palette.primary.main}`
                              : "none",
                          "&:hover": {
                            backgroundColor:
                              location.pathname === item.path
                                ? (theme) => theme.palette.primary.main
                                : (theme) => theme.palette.action.hover,
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            color:
                              location.pathname === item.path
                                ? "#fff"
                                : (theme) => theme.palette.text.primary,
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText primary={item.text} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              </React.Fragment>
            ))}
          </List>
        </Drawer>
      )}

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          padding: 3,
          marginLeft: !isLoginPage
            ? { sm: collapsed ? "60px" : `${drawerWidth}px` }
            : 0,
          transition: "margin 0.3s ease-in-out", // Smooth transition effect
          display: isLoginPage ? "flex" : "block",
          justifyContent: isLoginPage ? "center" : "initial",
          alignItems: isLoginPage ? "center" : "initial",
        }}
      >
        {isMobile && <Toolbar />}
        <Outlet />

        {/* Roles without the overview permission land on their own queue. */}
        {location.pathname === "/dashboard" && !permissions.dashboard && (
          <RoleLanding />
        )}

        {location.pathname === "/dashboard" && permissions.dashboard && (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 3,
                p: 2,
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              <Title text="Dashboard" />

              {/* <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: isMobile
                    ? "repeat(2, 1fr)"
                    : "repeat(4, 1fr)",
                  gap: 2,
                }}
              >
                {countCards.map((item, idx) => (
                  <Card
                    key={idx}
                    {...item}
                    onClick={() => handleCardClick(item.label)}
                  />
                ))}
              </Box> */}

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: isMobile
                    ? "1fr"
                    : "repeat(auto-fit, minmax(270px, 1fr))",
                  gap: 4,
                  width: "100%",
                }}
              >
                <InfoCard
                  title="Total Doctors"
                  count={doctors}
                  description="Active professional Dentists"
                  onClick={handleClickDoctor}
                  bgColor="primary.light"
                />

                <InfoCard
                  title="Total Air"
                  count={kiosk}
                  description="Active Air in operation"
                  onClick={handleClickKiosk}
                  bgColor="secondary.light"
                />
                <InfoCard
                  title="Total Patients"
                  count={user}
                  description="Overall Patients"
                  onClick={handleClickPatient}
                  bgColor="secondary.light"
                />
                <InfoCard
                  title="Total Scans"
                  count={scanCount}
                  description="Overall scans excluding internal"
                  // onClick={handleClickPatient}
                  bgColor="primary.light"
                />
              </Box>
              {Loader && <PageLoader />}
            </Box>
            {!isMobile && (
              <Box>
                <Box mb={2}>
                  <OverAllDaywise />
                </Box>
                <Box>
                  <OverAllMonthwise />
                </Box>
              </Box>
            )}
          </>
        )}
        <>
          <ModalActivations
            label={label}
            isOpen={isModalOpen}
            onClose={() => setModalOpen(false)}
            clinics={clinics}
          />
        </>
      </Box>
    </Box>
  );
};

export default Dashboard;
